import { render, staticRenderFns } from "./PlaylistDetail.vue?vue&type=template&id=08aaf602&scoped=true"
import script from "./PlaylistDetail.vue?vue&type=script&lang=js"
export * from "./PlaylistDetail.vue?vue&type=script&lang=js"
import style0 from "./PlaylistDetail.vue?vue&type=style&index=0&id=08aaf602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aaf602",
  null
  
)

export default component.exports